export default __webpack_public_path__ + "assets/1329aeb88525096760c4a09db5673334.png";